import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-cancel-account-dialog',
    templateUrl: './cancel-account-dialog.component.html',
    styleUrls: ['./cancel-account-dialog.component.css'],
    standalone: false
})
export class CancelAccountDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CancelAccountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onStay(): void {
    this.dialogRef.close(false);
  }

  onContinueCancel(): void {
    this.dialogRef.close(true);
  }
}
